var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsLinkedin = function SvgMillustrationsLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "M33.105 14h-10.21a.89.89 0 0 0-.895.865V25.1c.01.485.41.87.895.865h10.21A.885.885 0 0 0 34 25.1V14.865a.89.89 0 0 0-.895-.865m-7.55 10.205h-1.76V18.5h1.76zm-.86-6.5a1.035 1.035 0 0 1-.743-1.753 1 1 0 0 1 .743-.292 1.035 1.035 0 0 1 0 2.065zm7.545 6.465H30.5v-2.79c0-.665 0-1.53-.93-1.53s-1.07.73-1.07 1.465v2.825h-1.78V18.5h1.66v.75h.035a1.86 1.86 0 0 1 1.695-.93c1.795 0 2.13 1.2 2.13 2.725z",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsLinkedin;